// /transcode-presets: the video presets (W12). Listed for viewer+ (x-min-role
// of listTranscodePresets) in the advanced view of "Настройка"; the create,
// edit and delete buttons gate themselves per operation (engineer).
import { operationMinRole } from '@/api/access'
import { defineFeatureRoutes } from '@/app/router/registry'
import { messages } from './i18n'

export const TRANSCODE_PRESETS_ROUTE = 'transcode-presets'

export default defineFeatureRoutes([
  {
    path: '/transcode-presets',
    name: TRANSCODE_PRESETS_ROUTE,
    component: () => import('./TranscodePresetsView.vue'),
    meta: {
      title: messages.lazy('navTitle'),
      minRole: operationMinRole('listTranscodePresets') ?? undefined,
      nav: { order: 44, icon: 'transcode', group: 'setup', advanced: true },
    },
  },
])
